import React from "react";
import { Link, withRouter } from "react-router-dom";

const Home = () => {
  return (
    <div className="mt-5">
      <h5 className="start-title mt-5 text-warning text-mk p-0">TOYS </h5>
      <h5 className="start-title mortal-title text-warning text-mk p-0">MORTAL</h5>
      <h5 className="fight-title p-0 text-mk">FIGHT</h5>
      <Link to="/players">
        <h6 className="text-gothic">
          <i className="fas fa-play-circle mr-2 text-secondary" />
          START
        </h6>
      </Link>

      <Link to="/settings">
        <h6 className="text-gothic">
          <i className="fas fa-cog mr-2 text-secondary" />
          settings
        </h6>
      </Link>

      <div className="bg-dark text-dark">
        <p>&copy; 2020 - Agustin Ruiz Pastorino</p>
      </div>
    </div>
  );
};

export default withRouter(Home);
